"use client";

import PageNotFoundImage from "../_icons/pageNotFound";
import { Action } from "@clover-web-lib-sprout/action";
import pom from "@/utils/pom";
import { applyDataTestId } from "@/utils/testUtils";

export default function PageNotFound() {
  const handleClick = () => {
    window.location.href = `/`;
  };

  return (
    <div className="w-full flex flex-col items-center justify-center h-[60vh]">
      <PageNotFoundImage />
      <h2
        className="text-[32px] leading-[40px] mt-[22px] mb-[22px]"
        data-testid={applyDataTestId(pom.notFoundPage.title)}
      >
        {"Page not found"}
      </h2>
      <p className="mb-[35px]">
        {"It seems you've followed a broken link or entered an incorrect url."}
      </p>
      <Action onClick={handleClick}>{"Go to homepage"}</Action>
    </div>
  );
}
